import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getManagementUnitById, updateManagementUnit as updateManagementUnitApi } from "../../api/managementUnits";
import { UpdateManagementUnitRequest } from "../../types/model/managementUnit";

export const useManagementUnit = (managementUnitIdStr?: string) => {
  const queryClient = useQueryClient();
  const managementUnitId = Number(managementUnitIdStr);

  const result = useQuery({
    queryKey: ["managementUnit", managementUnitId, "details"],
    queryFn: () => getManagementUnitById(managementUnitId),
    enabled: !!managementUnitId,
  });

  const mutation = useMutation({
    mutationFn: (values: UpdateManagementUnitRequest) => updateManagementUnitApi(managementUnitId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["managementUnit", managementUnitId] });
    },
  });

  return {
    managementUnitData: result.data,
    update: mutation.mutateAsync,
    isPending: result.isPending,
    isUpdating: mutation.isPending,
    isError: result.isError,
    error: result.error,
    refetch: result.refetch,
  };
};
